import {
  businessUnitsKeys,
  RequestTypes,
} from '@core/react-query/features/businessUnits'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

export const useAddProjectsToBusinessUnit = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['addProjectToBusinessUnit']
  >,
) => {
  return useMutation({
    ...businessUnitsKeys.addProjectsToBusinessUnit,
    retry: 0,
    ...options,
  })
}
